module.exports = __webpack_public_path__ + "img/product_service11.c2f22587.png";